import { SetGetHistoryBonusGetById } from './thunk/setGetHistoryBonusGetById';
import { SetGetJackpotHistoryList } from './thunk/setGetJackpotHistoryList';
import { SetGetJackpotList } from './thunk/setGetJackpotList';
import { SetGetLastOperation } from './thunk/setGetLastOperation';
import { SetGetReplenishmentUser } from './thunk/setGetReplenishmentUser';
import { SetPostJackpotIssue } from './thunk/setPostJackpotIssue';
import { SetUpdatePassword } from './thunk/setUpdatePassword';
import { SetGetRezyme } from './thunk/setGetRezyme';
import { SetGetUserById } from './thunk/setGetUserById';
import { SetGetUsers } from './thunk/setGetUsers';
import { SetGetWithdrawalsUser } from './thunk/setGetWithdrawalsUser';
import { SetPostBlockUser } from './thunk/setPostBlockUser';

export const Thunks = {
    SetGetHistoryBonusGetById,
    SetGetJackpotHistoryList,
    SetGetJackpotList,
    SetGetLastOperation,
    SetGetReplenishmentUser,
    SetGetRezyme,
    SetGetUserById,
    SetGetUsers,
    SetGetWithdrawalsUser,
    SetPostBlockUser,
    SetPostJackpotIssue,
    SetUpdatePassword
}